function SearchObelisk() {

  return (
    <div>
      <div className='greenBar'>OBELISK FILES</div>

      <div className='searchBody'>
        <br/>
        Agent Papyrus claims he found this sentient statue in the great white desert of the Sahara. Official Agency records indicate it was invented in the 90s using stolen software from several competing search companies.
        <br /><br />It is Agency policy to follow the Obelisk's <a style={{color:'#f9df39'}} target='_blank' href='./obeliskterms'>terms and conditions.</a><br />
      </div>

    </div>
  )
}

export default SearchObelisk;